  <div id="main" [ngClass]="{'shifted': isOpen, 'backdrop': isOpen}" *ngIf="admin.isAdmin()" (click)="closeSidebar($event)">
    
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container-fluid">

        <a class="menu" (click)="toggleNav($event)" >
          <i class="fi fi-rr-bars-staggered"></i>
        </a>
       
        <ul class="nav">
          <li class="nav-item mt-1"> <span class="nav-link text-color">{{ admin.user.name }}</span></li>
          <li class="nav-item mt-1">
            <a class="nav-link" *ngIf="currentLang !== 'geo'" (click)="switchLanguage('geo')">
              <img class="flag" src="/assets/images/ge.png" alt="ქართული" />
            </a>
            <a class="nav-link " *ngIf="currentLang !== 'eng'" (click)="switchLanguage('eng')">
              <img class="flag" src="/assets/images/us.png" alt="English" />
            </a>
          </li>

           <li class="nav-item">
            <a class="nav-link text-color" href="https://sca.ge/" target="_blank" ><i class="fi fi-rr-site-alt"></i></a>
          </li>

          <li class="nav-item ">
            <a class="nav-link text-color" (click)="logout()"><i class="fi fi-rr-sign-out-alt"></i></a>
          </li>
        </ul>
        

      </div>
    </nav> 

 
    <div #scrollContainer style="height: 100vh; overflow-y: auto;">
      <router-outlet></router-outlet>
    </div>

  </div>

  <div class="container-fluid" *ngIf="!admin.isAdmin()">
    <router-outlet></router-outlet>
  </div>

  <div class="sidebar" [ngClass]="{'open': isOpen}" *ngIf="admin.isAdmin()">
    <a routerLink="/">
      <img src="assets/logo/logo.svg" class="logo-sidebar ps-4"/>
    </a>


    <div class="list-group list-group-flush  ps-4 mt-2">

      <!-- <a 
        class="list-group-item d-flex" 
        [routerLink]="['/']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"

        >
          <i class="fi fi-rr-house-chimney"></i>
          <span class="mx-1">მთავარი</span>
      </a> -->
     <a 
        class="list-group-item d-flex" 
        [routerLink]="['/menu']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('menu')"
        >
          <i class="fi fi-rr-drop-down"></i>
          <span class="mx-1">მენიუ</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/posts']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('posts')">
           <i class="fi fi-rr-newspaper"></i>
          <span class="mx-1">სტატიები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/team']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()" 
        *ngIf="admin.hasPermission('team')">
          <!-- <i class="fi fi-rs-employees"></i> -->
          <i class="fi fi-rr-people"></i>
          <span class="mx-1">ჩვენი გუნდი</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/banner']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('banner')">
           <!-- <i class="fi fi-rr-sliders-v"></i> -->
          <i class="fi fi-rr-banner-5"></i>
          <span class="mx-1">ბანერები</span>
      </a>


      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/form']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('form')">
           <!-- <i class="fi fi-rr-sliders-v"></i> -->
          <i class="fi fi-rr-form"></i>
          <span class="mx-1">ფორუმები</span>
      </a>

       <a 
        class="list-group-item d-flex" 
        [routerLink]="['/contact']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('contact')">
           <!-- <i class="fi fi-rr-sliders-v"></i> -->
          <i class="fi fi-rr-phone-guide"></i>
          <span class="mx-1">საკ. ინფო</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/files']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()">
          <i class="fi fi-rr-folder-open"></i>
          <span class="mx-1">ფაილები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/admins']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('admins')">
           <i class="fi fi-rr-admin-alt"></i>
          <span class="mx-1">ადმინები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/setting']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('settings')">
           <i class="fi fi-rr-settings"></i>
          <span class="mx-1">პარამეტრები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/database']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('database')">
          <i class="fi fi-rr-database"></i>
          <span class="mx-1">ბაზა</span>
      </a>

      
      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/logs']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('logs')">
          <i class="fi fi-rs-file-circle-info"></i>
          <span class="mx-1">ლოგები</span>
      </a>

      <a 
        class="list-group-item d-flex" 
        [routerLink]="['/info']" 
        routerLinkActive="active" 
        [routerLinkActiveOptions]="{ exact: true }" 
        (click)="menuItemClicked()"
        *ngIf="admin.hasPermission('info')">
          <i class="fi fi-rr-info"></i>
          <span class="mx-1">ინფო</span>
      </a>
      
      

    </div>
  </div>






